{
	"type": "line",
	"minzoom": 0,
	"layout": {
		"line-cap": "square",
		"line-sort-key": ["*", ["get", "frc"], -1]
	},
	"paint": {
		"line-color": [
			"match",
			["get", "aadt_symbology_band"],
			"0 - 100",
			"#fcfdbf",
			"100 - 200",
			"#fec98d",
			"200 - 500",
			"#fd9567",
			"500 - 1000",
			"#f1605d",
			"1000 - 2400",
			"#cd3f71",
			"2400 - 5000",
			"#9e2f7f",
			"5000 - 8000",
			"#721f81",
			"8000 - 12000",
			"#450f76",
			"12000 - 20000",
			"#180f3e",
			"20000+",
			"#000004",
			"#0072e9"
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 1, 18, 6],
		"line-blur": 1,
		"line-opacity": 1
	}
}
